import config from "src/config/config"

export function maintenanceHttpBase() {
  const graphqlUrl = config.quark?.url || ""
  return graphqlUrl.replace(/\/graphql\/?$/i, "").replace(/\/$/, "")
}
